import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from './constants';
import { secureFetch } from './authService';

export function getRetailApps(query) {
	let url = API_BASE_URL + '/retail/market?';
	if (query) {
		let {companyId, limit = PAGINATION_DEFAULT_LIMIT, page = 0, filter, onlyNeedUpdating, mobileAppIds} = query;

		if (companyId) {
			url = url + `&companyId=${companyId}`
		}

		if (limit) {
			url = url + `&limit=${limit}`
		}

		if (page || page === 0) {
			url = url + `&page=${page}`
		}

		if (filter) {
			url = url + `&filter=${filter}`
		}
		if (onlyNeedUpdating) {
			url = url + `&onlyNeedUpdating=${onlyNeedUpdating}`
		}
		if (mobileAppIds) {
			url = url + `&mobileAppIds=${mobileAppIds}`
		}
	}

	return secureFetch(url, {
		method: 'GET'
	});
}

export function getRetailPackagesList(query) {
	let url = API_BASE_URL + '/retail/bundles?';
	if (query) {
		let {companyId, limit = PAGINATION_DEFAULT_LIMIT, page = 0, filter} = query;

		if (companyId) {
			url = url + `&companyId=${companyId}`
		}

		if (limit) {
			url = url + `&limit=${limit}`
		}

		if (page) {
			url = url + `&page=${page}`
		}

		if (filter) {
			url = url + `&filter=${filter}`
		}
	}
	return secureFetch(url, {
		method: 'GET'
	});
}

export function getRetailPackage(query) {
	let url = API_BASE_URL + `/retail/bundles/${query.packageId}/marketRetailItems?`;

	if (query) {
		let {limit = PAGINATION_DEFAULT_LIMIT, page = 0, filter} = query;

		if (limit) {
			url = url + `&limit=${limit}`
		}

		if (page || page === 0) {
			url = url + `&page=${page}`
		}

		if (filter) {
			url = url + `&filter=${filter}`
		}
	}

	return secureFetch(url, {
		method: 'GET'
	});
}

export function moveAppToRetail(appId) {
	return secureFetch(API_BASE_URL + `/retail/market/marketItem/${appId}`, {
		method: 'DELETE'
	});
}

export function addPackage(retailPackage) {
	return secureFetch(API_BASE_URL + '/retail/bundles', {
		method: 'POST',
		body: JSON.stringify(retailPackage)
	});
}

export function changePackageName(pack) {
	return secureFetch(API_BASE_URL + `/retail/bundles/${pack.id}`, {
		method: 'PUT',
		body: JSON.stringify({
			name: pack.name
		})
	});
}

export function addToPackage(apps, bundleId) {
	return secureFetch(API_BASE_URL + `/retail/bundles/${bundleId}/addItems`, {
		method: 'POST',
		body: JSON.stringify(apps)
	});
}

export function removeFromPackage(apps, bundleId) {
	return secureFetch(API_BASE_URL + `/retail/bundles/${bundleId}/removeItems`, {
		method: 'POST',
		body: JSON.stringify(apps)
	});
}

export function deletePackage(bundleId) {
	return secureFetch(API_BASE_URL + `/retail/bundles/${bundleId}`, {
		method: 'DELETE'
	});
}



// WEBPACK FOOTER //
// ./src/helpers/retailService.js